import GameResultsModel from "./GameResultsModel";
import TiebreakerModel from "./TiebreakerModel";

export default class GameModel {
    public userId: string = null;
    public points: number = null;
    public results: GameResultsModel[] = [];
    public tiebreaker: TiebreakerModel = null;
}